import type {CreateLeadFormPayload} from "./create-lead.schema";

import {createLead} from "@project/sdk/sales";
import {mutationOptions} from "@tanstack/react-query";

import {leadKeys, leadMutationKeys} from "../../../lead-keys";

import {createLeadMapper} from "./create-lead.mapper";

export function createLeadMutationOptions() {
  return mutationOptions({
    mutationFn: (payload: CreateLeadFormPayload) => {
      const request = createLeadMapper.toSdk(payload);

      return createLead(request);
    },
    mutationKey: leadMutationKeys.createLead,
    onSuccess: async (_leadId, _payload, _onMutateResult, {client}) => {
      await client.invalidateQueries({queryKey: leadKeys.lists()});
    },
  });
}
